module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('h2', [_vm._v("Region Info")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "25%",
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Regions:")])]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncSplitObject(_vm.objUserInfo.user_locations))
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-2 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}